export default __webpack_public_path__ + "static/media/InstallAgent2.1fb771c3.md";